export enum TranslationMethodEnum {
  UserPreference = 'UserPreference',
  FullUserLocaleMatch = 'FullUserLocaleMatch',
  PartialUserLocaleMatch = 'PartialUserLocaleMatch',
  Preview = 'Preview',
  None = 'NONE',
}
